const productsData = [
  {
    id: 'alianza-autoridad',
    title: 'Alianza de Autoridad',
    product: 'Vocería + Presencia de marca',
    investment: '$450 USD / mes',
    impacts: [
      'Vocería de Angélica Lugo con sello de veracidad periodística.',
      'Segmento "El Expediente de la Piel": espacio quincenal con rigor científico sobre composición de productos Atache.',
      'Ciclo de entrevistas con dermatólogos, cirujanos plásticos y especialistas en medicina estética.',
      'Inserts de marca en clips promocionales del programa para redes sociales.',
      'Logo de Atache de forma permanente en el mini-site de Expedientes del Delito en TNO Network.',
    ],
  },
  {
    id: 'agencia-creativa',
    title: 'Agencia Creativa & Redes',
    product: 'Contenido audiovisual',
    investment: '$300 USD / mes',
    impacts: [
      '8 piezas de video mensuales (2 Reels/TikToks semanales) de alta factura visual.',
      'Redes de la marca activas, dinámicas y profesionales.',
      'Todo el contenido se comparte en las redes de Angélica Lugo, TNO Network y todas las cuentas del ecosistema.',
      'Cápsulas informativas de entrevistas médicas para rotativa de TNO Network y RRSS.',
      'Contenido UGC: momentos orgánicos de Angélica Lugo y Santiago en preparación (maquillaje y piel).',
    ],
  },
  {
    id: 'tno-digest',
    title: 'Estrategia TNO Digest',
    product: 'Contenido editorial',
    investment: '$100 USD / mes',
    impacts: [
      '4 artículos de fondo mensuales (1 semanal) con enfoque SEO.',
      'Historia de 90 años de Laboratorios Vital Pharma y educación al mercado.',
      'Autoridad de contenido que vincula Atache con dermocosmética científica.',
    ],
  },
  {
    id: 'omnicanalidad',
    title: 'Omnicanalidad TNO',
    product: 'Presencia multiplataforma',
    investment: '$100 USD / mes',
    impacts: [
      'Cuñas, banners y rotativa de micro-audiovisuales.',
      'Bonificación: Banner en página principal de TNO Network.',
      'Micro-audiovisuales de autoridad médica en rotativa de la señal.',
    ],
  },
];

export default productsData;
